import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isExpired } from 'react-jwt';
import { getMe, logout, setMe } from './redux/actions/auth.action';
import { useEffect, useState } from 'react';
import Loader from './components/Loader';
import HomePage from './pages/HomePage';
import EmployeesPage from './pages/employees/EmployeesPage';
import ProductsPage from './pages/products/ProductsPage';
import OrdersPage from './pages/orders/OrdersPage';
import SuppliersPage from './pages/suppliers/SuppliersPage';
import ClientsPage from './pages/clients/ClientsPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import UsersPage from './pages/users/UsersPage';
import SettingPage from './pages/SettingPage';
import InvoicesPage from './pages/invoices/InvoicesPage';
import PackagingPage from './pages/packagings/PackagingPage';
import DelivryNotesPage from './pages/delivry-notes/DelivryNotesPage';
import NotFoundPage from './pages/NotFoundPage';
import Packagings from './pages/packagings/Packagings';
import PackagingHistoryPage from './pages/packagings/PackagingHistoryPage';
import CategoriesPage from './pages/categories/CategoriesPage';
import ArticlesPage from './pages/articles/ArticlesPage';
import ProformaInvoicesPage from './pages/proforma-invoices/ProformaInvoicesPage';
import ExpensesPage from './pages/expenses/ExpensesPage';
import Tasks from './pages/tasks/Tasks';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RawMaterials from './pages/raw-materials/RawMaterials';
import RawMaterialIndex from './pages/raw-materials/RawMaterialIndex';
import RambosPage from './pages/raw-materials/RambosPage';
import BambousPage from './pages/raw-materials/BambousPage';
import TaskIndex from './pages/tasks/TaskIndex';
import TaskRamboPage from './pages/tasks/TaskRamboPage';
import TaskBambouPage from './pages/tasks/TaskBambouPage';

function App() {
  const { me, loading } = useSelector(state => state.auth);
  const loader = useSelector(state => state.loader);
  const loginData = useSelector(state => state.login);
  const usersData = useSelector(state => state.users);
  const employeesData = useSelector(state => state.employees);
  const suppliersData = useSelector(state => state.suppliers);
  const clientsData = useSelector(state => state.clients);
  const rambosData = useSelector(state => state.rambos);
  const bambousData = useSelector(state => state.bambous);
  const productsData = useSelector(state => state.products);
  const ordersData = useSelector(state => state.orders);
  const invoicesData = useSelector(state => state.invoices);
  const delivryNotesData = useSelector(state => state.delivryNotes);
  const packagingList = useSelector(state => state.packagingList);
  const setting = useSelector(state => state.setting);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isOnline, setIsOnline] = useState(window.navigator.onLine);
  const [showReconnectMessage, setShowReconnectMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnectMessage(true);
      setTimeout(() => setShowReconnectMessage(false), 5000); // 5 secondes
    }

    const handleOffline = () => {
      setIsOnline(false);
      setShowReconnectMessage(false);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    const jwt_access = localStorage.getItem('jwt_access');
    if(jwt_access){
      if(!isExpired(jwt_access)){
        if(!me){
          dispatch(getMe(location.pathname + location.search, navigate));
        }
      }else{
        dispatch(logout(location.pathname + location.search));
      }
    }else{
      dispatch(setMe(null));
    }
  }, [location, dispatch, me, navigate]);

  return (
    <>
      {/* { !isOnline && <div className="offline-alert-container">
        <div className='offline-alert'><span><i className="fa fa-times"></i></span> Connexion interrompue</div>
      </div> }
      { showReconnectMessage && <div className="reconnect-alert-container">
        <div className='reconnect-alert'><span><i className="fa fa-check"></i></span> Connexion rétablie</div>
      </div> } */}
      
      <Loader load={ loading || loader.loading || loginData.loading || usersData.loading || employeesData.loading || suppliersData.loading || rambosData.loading || bambousData.loading || clientsData.loading || productsData.loading || packagingList.loading || ordersData.loading || invoicesData.loading || delivryNotesData.loading || setting.loading } />
      <Routes>
        <Route path='/' element={ <HomePage /> }></Route>
        <Route path='/expenses' element={ <ExpensesPage /> }></Route>
        <Route path='/employees' element={ <EmployeesPage /> }></Route>
        <Route path='/raw-materials' element={ <RawMaterials /> }>
          <Route index element={ <RawMaterialIndex /> }></Route>
          <Route path='rambos' element={ <RambosPage /> }></Route>
          <Route path='bambous' element={ <BambousPage /> }></Route>
        </Route>
        <Route path='/categories' element={ <CategoriesPage /> }></Route>
        <Route path='/products' element={ <ProductsPage /> }></Route>
        <Route path='/packagings' element={ <Packagings /> }>
          <Route index element={ <PackagingPage /> }></Route>
          <Route path='history' element={ <PackagingHistoryPage /> }></Route>
        </Route>
        <Route path='/orders' element={ <OrdersPage /> }></Route>
        <Route path='/suppliers' element={ <SuppliersPage /> }></Route>
        <Route path='/clients' element={ <ClientsPage /> }></Route>
        <Route path='/users' element={ <UsersPage /> }></Route>
        <Route path='/proforma-invoices' element={ <ProformaInvoicesPage /> }></Route>
        <Route path='/invoices' element={ <InvoicesPage /> }></Route>
        <Route path='/delivry-notes' element={ <DelivryNotesPage /> }></Route>
        <Route path='/tasks' element={ <Tasks /> }>
          <Route index element={ <TaskIndex /> }></Route>
          <Route path='rambos' element={ <TaskRamboPage /> }></Route>
          <Route path='bambous' element={ <TaskBambouPage /> }></Route>
        </Route>
        <Route path='/articles' element={ <ArticlesPage /> }></Route>
        <Route path='/settings' element={ <SettingPage /> }></Route>
        <Route path='/login' element={ <LoginPage /> }></Route>
        <Route path='/forgot-password' element={ <ForgotPasswordPage /> }></Route>
        <Route path='/reset-password/:id/:token' element={ <ResetPasswordPage /> }></Route>
        <Route path='*' element={ <NotFoundPage /> }></Route>
      </Routes>
    </>
  );
}

export default App;
